var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse",class:{ open: _vm.open }},[_c('div',{staticClass:"toggle",on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"icon"},[_vm._v("▼")])]),(_vm.open)?_c('div',{staticClass:"content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }